
import { Component, Vue, Prop } from 'vue-property-decorator';
import TInputCloseBtn from '@/components/btns/TInputCloseBtn.vue';

@Component({
  components: {
    TInputCloseBtn,
  },
})
export default class TicketSearchField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loadingSearch: boolean;
  @Prop(Function) public getTicketsWrapper: () => Promise<void>;

  get searchValue() {
    return this.value;
  }

  set searchValue(value) {
    this.$emit('input', value);
  }
}
